<div class="date-range-wrapper">
  <input
    #rangeInput
    class="date-range-input"
    type="text"
    ngxDaterangepickerMd
    [locale]="locale"
    [timePicker]="timePicker"
    [timePicker24Hour]="timePicker24Hour"
    [timePickerIncrement]="1"
    [linkedCalendars]="linkedCalendars"
    [showDropdowns]="showDropdowns"
    [alwaysShowCalendars]="true"
    [ranges]="ranges"
    [showCustomRangeLabel]="true"
    [showCancel]="true"
    [keepCalendarOpeningWithRange]="true"
    [maxDate]="maxDate"
    [isInvalidDate]="isInvalidDate"
    [ngModel]="selected"
    [showClearButton]="false"
    [opens]="opens"
    [drops]="drops"
    (click)="updateOpens(rangeInput)"
    (datesUpdated)="onDatesUpdated($event)"
    readonly
  />
</div>